<template>
  <div class="call-for-pages">
    <section class="conference-details">
      <h1>4st International Conference on Tropical Plants (ICTP)</h1>
<!--      <p>Submission Link:
        <a href="https://easychair.org/conferences/?conf=1stictp" target="_blank">EasyChair Submission Link</a>
      </p>-->
      <p>
        The conference will collaborate with six, high-level academic journals to provide manuscript recommendation and selection service for participants. Each participant can submit only one manuscript, and each manuscript can select only two journals. The submission and review processing time for selected manuscripts will be drastically reduced and the acceptance rate will be an increase on the standard acceptance rate.
      </p>
    </section>

    <section class="journal-list">
      <h2>Journal List</h2>
      <ul>
        <li>Tropical Plants (A new journal, the first IF is expected to be 4-5)</li>
      </ul>
    </section>

<!--    <section class="submission-process">
      <h2>Submission Process</h2>
      <ol>
        <li>
          Access the submission system EasyChair:
          <a href="https://easychair.org/conferences/?conf=1stictp" target="_blank">EasyChair Submission Link</a>, register and log in, click "make a new submission", and follow the instructions on the website.
          <p>Note: When filling out the TITLE text box, use parentheses to mark the selected journals (the serial number is as above).
            e.g. If Horticulture Research and Plant Phenomics are selected, then the TITLE text box should be: (1,2) + manuscript title.</p>
        </li>
        <li>
          You only need to submit an extended abstract (with two-three figures), not the full text. The editor will quickly review the quality of the manuscript and provide preliminary review comments.
        </li>
      </ol>
      <p>Manuscript submission deadline: <strong>February 8, 2023</strong>.</p>
    </section>-->

    <section class="contact-info">
      <p>If you have any questions, please contact <a href="mailto:fananqi@maxapress.com">fananqi@maxapress.com</a> (Ms. Fan)</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CallForPages'
};
</script>

<style scoped>
.call-for-pages {
  max-width: 66%;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.conference-details, .submission-process, .contact-info {
  margin-bottom: 20px;
}

h1 {
  color: #2c3e50;
  text-align: center;
}

h2 {
  color: #16a085;
  margin-top: 20px;
}

ul {
  list-style-type: decimal;
  padding-left: 20px;
}

ol {
  padding-left: 20px;
}

a {
  color: #3498db;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

p {
  line-height: 1.6;
}
</style>
